import { FC } from "react";

import { Stack, StackProps } from "@mui/material";
import Image from "next/image";

import { Trans, useTranslate } from "@/common/hooks/useTranslate";
import { DashboardLink } from "@/dashboard-design-system/Link/DashboardLink";
import { DashboardTypography } from "@/dashboard-design-system/Typography/DashboardTypography";

type GenericErrorDisclaimerProps = Omit<ErrorDisclaimerProps, "title" | "description">;

export const GenericErrorDisclaimer: FC<GenericErrorDisclaimerProps> = (props) => {
  const { t } = useTranslate();

  return (
    <ErrorDisclaimer
      {...props}
      title={t("common", "genericError.title")}
      description={
        <Trans
          space="common"
          i18nKey="genericError.description"
          components={{ email: <DashboardLink href="mailto:contact@zeffy.com" underline="hover" /> }}
        />
      }
    />
  );
};

type ErrorDisclaimerProps = {
  title: React.ReactNode;
  description: React.ReactNode;
} & Omit<StackProps, "alignItems" | "gap" | "children">;

export const ErrorDisclaimer: FC<ErrorDisclaimerProps> = ({ title, description, ...props }) => {
  return (
    <Stack alignItems="center" justifyContent="center" gap={2} {...props}>
      <Image src="/images/light-bulb.svg" alt="Light bulb" width={275} height={110} />
      <DashboardTypography variant="h3" textAlign="center">
        {title}
      </DashboardTypography>
      <DashboardTypography variant="body1" textAlign="center" sx={{ maxWidth: "50ch" }}>
        {description}
      </DashboardTypography>
    </Stack>
  );
};
